import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './AddRemarks.css';
import TauriImage from '../../../TauriImage/TauriImage';

const AddRemarks = ({ show, onHide, onRemarks }) => {
    const [sessionRemarks, setSessionRemarks] = useState('');

    const handleUpdate = () => {
        if (onRemarks) {
            onRemarks(sessionRemarks); // Pass remarks to parent
        }
        onHide(); // Close modal after update
    };

    useEffect(() => {
        setSessionRemarks('');
    }, [show])
    
    return (
        <Modal className='finish-session-remarks-modal' 
        show={show} 
        onHide={() => onHide(null)} size="lg" 
        backdrop={"static"}
        keyboard={false}
        centered>
            <Modal.Header>Finish Session</Modal.Header>
            <Modal.Body className="modal-body-flex">
                <div className="textarea-wrapper">
                    <textarea
                        className="form-control textarea-expand"
                        value={sessionRemarks}
                        onChange={(e) => setSessionRemarks(e.target.value)}
                        placeholder="Type to input your Remarks"
                    />
                </div>
            </Modal.Body>

            <Modal.Footer className="justify-content-between">
                <Button className="btn-history" onClick={handleUpdate}>
                    <TauriImage localImage={"/Images/notes.svg"} className={"history"} alt='icon' color={"#000"} />
                    <div>History</div>
                </Button>
                <Button className="btn-finish-session" onClick={handleUpdate}>Update</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddRemarks;
